export let LoginValidationMessages: Record<
    string,
    Record<string, string | ((error: any) => string)>
> = {
    email: {
        required: 'Email is required.',
        email: 'Email must be a valid email address.',
    },
    password: {
        required: 'Password is required.',
        minlength: (error) =>
            `Password must be at least ${error.requiredLength} characters.`,
    },
    otp: {
        required: 'OTP is required.',
        minlength: (error) =>
            `OTP must be at least ${error.requiredLength} digits.`,
        maxlength: (error) =>
            `OTP must be at most ${error.requiredLength} digits.`,
        pattern: 'OTP must contain only numeric digits.',
    },
};
